import { supabase } from './supabase';

export const getRestaurantOrders = async (restaurantId, status = null) => {
  try {
    console.log('Fetching orders for restaurant:', restaurantId, 'status:', status);
    
    let query = supabase
      .from('orders')
      .select(`
        *,
        order_items (*)
      `)
      .eq('restaurant_id', restaurantId)
      .order('created_at', { ascending: false });
      
    if (status && status !== 'all') {
      query = query.eq('status', status);
    }

    const { data, error } = await query;
    
    if (error) {
      console.error('Database error fetching orders:', error);
      throw error;
    }
    
    console.log('Orders fetched successfully:', data?.length || 0, 'orders');
    return data || [];
  } catch (error) {
    console.error('Error in getRestaurantOrders:', error);
    // Return empty array instead of throwing to prevent complete failure
    return [];
  }
};

export const updateOrderStatus = async (orderId, status) => {
  try {
    const { data, error } = await supabase
      .from('orders')
      .update({ 
        status, 
        updated_at: new Date().toISOString()
      })
      .eq('id', orderId)
      .select()
      .single();
      
    if (error) {
      console.error('Error updating order status:', error);
      throw error;
    }
    
    return data;
  } catch (error) {
    console.error('Error in updateOrderStatus:', error);
    throw error;
  }
};

export const getOrder = async (orderId) => {
  try {
    console.log(`Fetching order with ID: ${orderId}`);
    
    const { data: order, error } = await supabase
      .from('orders')
      .select(`
        *,
        restaurants (
          name,
          user_id
        ),
        order_items (*)
      `)
      .eq('id', orderId)
      .single();
      
    if (error) {
      console.error('Error fetching order:', error);
      throw error;
    }
    
    console.log('Order fetched successfully:', order);
    return order;
  } catch (error) {
    console.error('Error in getOrder:', error);
    throw error;
  }
};